import React from "react";
import {
  IonRow,
  IonCol,
  IonCard,
  IonIcon,
  IonButton,
  IonBadge,
} from "@ionic/react";
import {
  banOutline,
  cashOutline,
  chatboxOutline,
  closeCircleOutline,
  diamond,
} from "ionicons/icons";
import { collectionGroup, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import "../theme/AppStyles.css";
import { AllAssociatedJobsDocs } from "./AllAssociatedJobsDocs";
import { JobStatsSummary } from "./JobStatsSummary";

// https://www.youtube.com/watch?v=fgHPkWqqdpo


export const SchedulerJobCards: React.FC<any> = ({ jobsArray }: { jobsArray: any[] }) => {
    
  const [jobDetails, setJobDetails] = React.useState<any[]>([]);
  const [viewJobDetails, setViewJobDetails] = React.useState<boolean>(false);
  const [selectedJobId, setSelectedJobId] = React.useState<string | null>(null);

  // console.log("SchedulerJobCards");
  // console.log("Jobs Array in SchedulerJobCards:", jobsArray);

  const handleJobDetails = async (e: any) => {
    const jobDocId = e.currentTarget.getAttribute("data-job-doc-id");
    // console.log("Clicked Job Doc ID:", jobDocId);
    // Navigate to job details page

    // Query Firestore to get all the jobs, and sort to put the scheduler's jobs first

    const jobQuery = query(
      collectionGroup(db, "jobsDocs"),
      where("jobInfo.core.uniqueJobId", "==", jobDocId)
    );
    const snapshot = await getDocs(jobQuery);

    const tempJobDetails: any[] = [];
    snapshot.forEach(async (jobDoc) => {
      const jobData = jobDoc.data();
      // console.log("Job Data Retrieved:", jobData);
      tempJobDetails.push(jobData);
    });
    setSelectedJobId(jobDocId);
    setJobDetails(tempJobDetails);
    setViewJobDetails(true);
  };

  const clearFilter = () => {
    setSelectedJobId(null);
    setViewJobDetails(false);
  };

  const filteredJobs = selectedJobId 
    ? jobsArray.filter(job => job.JobDocId === selectedJobId)
    : jobsArray;

  const sortedJobs = [...filteredJobs].sort((a, b) => {
    const dateA = new Date(a.DateDay);
    const dateB = new Date(b.DateDay);
    return dateA.getTime() - dateB.getTime();
  });

    return (
      <React.Fragment>
        
        <>
          {selectedJobId && (
            <IonButton
                expand="block"
                color="medium"
                onClick={clearFilter}
                style={{ margin: "15px" }}            >
              <IonIcon icon={closeCircleOutline} slot="start" />
              Clear Filter
            </IonButton>
          )}

          {sortedJobs.map(
            (job: {
              JobDocId: React.Key | any;
              Company: string | null | undefined;
              Pay: string | null | undefined;
              DateDay: string | null | undefined;
              StartDateTime: string | null | undefined;
              FinishDateTime: string | null | undefined;
              ShiftIdentifier: string | null | undefined;
              PaidWerkers: boolean | null | undefined;
              IsPaidJob: boolean | null | undefined;
              JobCancelledByScheduler: boolean;
              IsNewMessage: boolean | null | undefined;
              IsRead: boolean;
              Location: string | null | undefined;
              NumberOfJobSlots: number | null | undefined;
              RemainingSlots: number;
            }) => (
              <IonCard
                style={{ margin: "15px" }}
                key={job.JobDocId}
                className={
                  // schedAvailableJob.IsNewMessage === true ||
                  job.IsRead === false
                    ? "cardOutlineScheduler"
                    : ""
                }
                onClick={handleJobDetails}
                data-job-doc-id={job.JobDocId}
              >
                <IonRow
                >
                  <IonCol
                  ></IonCol>
                </IonRow>

                <IonRow
                >
                  <IonCol
                    size="7"
                  >
                    <h5 style={{ marginTop: "2px" }}>
                      {job.Company}
                    </h5>
                  </IonCol>
                  <IonCol
                  >
                    <IonIcon
                      icon={
                        job.JobCancelledByScheduler === true
                          ? banOutline
                          : ""
                      }
                      color={"danger"}
                    />
                  </IonCol>
                  <IonCol
                  >
                    <IonIcon
                      icon={
                        job.PaidWerkers === true
                          ? cashOutline
                          : ""
                      }
                      color={"dark"}
                    />
                  </IonCol>
                  <IonCol
                  >
                    <IonIcon
                      icon={job.IsPaidJob === true ? diamond : ""}
                      color={"dark"}
                    />
                  </IonCol>
                  <IonCol
                  >
                    <IonIcon
                      color={job.IsRead ? "medium" : "danger"}
                    />
                  </IonCol>
                </IonRow>

                <IonRow
                >
                  <IonCol
                  >
                    <strong>{job.ShiftIdentifier}</strong>
                  </IonCol>
                  <IonCol
                    class="ion-text-end"
                  >
                    <strong>{job.Pay}</strong>
                  </IonCol>
                </IonRow>
                <IonRow
                >
                  <IonCol
                  >
                    {job.DateDay} @{" "}
                    {job.StartDateTime} -{" "}
                    {job.FinishDateTime}
                  </IonCol>
                </IonRow>
                <IonRow
                >
                  <IonCol
                    size="9"
                  >
                    {job.Location}
                  </IonCol>
                  <IonCol
                  >
                    {job.IsNewMessage === true && (
                      <IonButton
                        color="light"
                      >
                        <IonIcon
                          size="large"
                          color="medium"
                          icon={chatboxOutline}
                        ></IonIcon>
                        <IonBadge
                          color="danger"
                          style={{
                            position: "absolute",
                            top: "0px",
                            right: "-5px", // Adjust this for positioning
                          }}
                        >
                          {"1"}
                        </IonBadge>
                      </IonButton>
                    )}
                    {job.IsNewMessage === false && (
                      <IonButton
                        color="light"
                        // onClick={() => routeToChat(schedAvailableJob.JobDocId)}
                      >
                        <IonIcon
                          // onClick={() =>
                          //   routeToChat(schedAvailableJob.JobDocId)
                          // }
                          size="large"
                          color="medium"
                          icon={chatboxOutline}
                        />
                      </IonButton>
                    )}
                  </IonCol>
                </IonRow>
                <IonRow
                >
                  <IonCol
                  >
                    Job Slots: {job.NumberOfJobSlots}
                  </IonCol>
                </IonRow>
              </IonCard>
            )
          )}
        </>
        {/* ) */
      }
      {viewJobDetails === true && 
        <>
        <JobStatsSummary jobsDocs={jobDetails} />
        <AllAssociatedJobsDocs detailsArray={jobDetails} />
        </>
      }
      </React.Fragment>
    );
  };
